import { COMMON_FILTER_FIELD_IDS } from '../../reports-components/shared-filter-fields';

export const CUSTOMER_REVENUE_CURRENCY_FIELD_ID = 'currency';

export const CUSTOMER_REVENUE_FILTER_FIELD_IDS = Object.freeze({
  CustomerId: COMMON_FILTER_FIELD_IDS.Customer,
  Currency: CUSTOMER_REVENUE_CURRENCY_FIELD_ID,
  Country: COMMON_FILTER_FIELD_IDS.Country,
  State: COMMON_FILTER_FIELD_IDS.State,
  Product: COMMON_FILTER_FIELD_IDS.Product,
  ContractStatus: COMMON_FILTER_FIELD_IDS.ContractStatus,
  Labels: COMMON_FILTER_FIELD_IDS.Labels,
  Plan: COMMON_FILTER_FIELD_IDS.Plan,
});
